import { render, staticRenderFns } from "./btn-dialog.vue?vue&type=template&id=58b397e1&"
import script from "./btn-dialog.vue?vue&type=script&lang=js&"
export * from "./btn-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports